import React from "react";

const Arrow = ({ color = "currentColor" }) => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16.926"
        height="16.926"
        viewBox="0 0 16.926 16.926"
      >
        <path
          id="Path_117"
          data-name="Path 117"
          d="M8.463,16.926l8.463-8.463L8.463,0l-2.4,2.4,4.52,4.52H0v3.085H10.582l-4.52,4.519Z"
          fill={color}
        />
      </svg>
    </>
  );
};
export default Arrow;
